/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramCategoryControllerFindOneByIdQueryResponse,
  TelegramCategoryControllerFindOneByIdPathParams,
  TelegramCategoryControllerFindOneById401,
  TelegramCategoryControllerFindOneById404,
} from '../types/TelegramCategoryControllerFindOneById.ts';

function getTelegramCategoryFindOneByIdUrl(id: TelegramCategoryControllerFindOneByIdPathParams['id']) {
  const res = { method: 'GET', url: `/api/telegram/category/id/${id}` as const };
  return res;
}

/**
 * {@link /api/telegram/category/id/:id}
 */
export async function telegramCategoryFindOneById(
  id: TelegramCategoryControllerFindOneByIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramCategoryControllerFindOneByIdQueryResponse,
    ResponseErrorConfig<TelegramCategoryControllerFindOneById401 | TelegramCategoryControllerFindOneById404>,
    unknown
  >({ method: 'GET', url: getTelegramCategoryFindOneByIdUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
